import React from 'react';
import { FieldLabel } from './FieldLabel';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toValidObjectIdString } from '../utils/security';
import './IadeKargoDetayModal.css';

const formatDateTime = (dateValue) => {
  if (!dateValue) return '—';
  try {
    const date = typeof dateValue === 'string' ? new Date(dateValue) : dateValue;
    if (!date || isNaN(date.getTime())) return '—';
    return date.toLocaleString('tr-TR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '—';
  }
};

const DURUM_LABEL = { KargoBekliyor: 'Kargo Bekliyor', Kargoda: 'Kargoda', Tamamlandi: 'Tamamlandı' };

const IadeKargoDetayModal = ({ iadeKargo, onClose, onKargoGir, onKargoTeslimAl }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isTechService = ['tech-service', 'teknikservis', 'techservice'].includes((user?.rol || '').toLowerCase());

  if (!iadeKargo) return null;

  const data = iadeKargo.veri || iadeKargo;
  const parcalar = Array.isArray(data.parcalar) ? data.parcalar : [];
  const kullanilmamisaparcalar = Array.isArray(data.kullanilmamisaparcalar) ? data.kullanilmamisaparcalar : [];
  const cihazlar = Array.isArray(data.cihazlar) ? data.cihazlar : [];
  const durum = data.durum || 'KargoBekliyor';
  const kargoBekliyor = durum === 'KargoBekliyor';
  const kargoda = durum === 'Kargoda';
  const servisKaydiId = data.servisKaydiId;
  const servisKaydiNumarasi = data.servisKaydiNumarasi;
  const iadeFaturaId = data.iadeFaturaId;
  const stoktanIade = data.stoktanIade ?? (!!iadeFaturaId && !servisKaydiId && data.siparisNumarasi === 'İade Fatura');

  const extractIdStr = (v) => {
    if (v == null) return null;
    const raw = typeof v === 'object' ? (v._id ?? v.id ?? v) : v;
    return toValidObjectIdString(raw);
  };


  return (
    <div className="modal-overlay iade-kargo-detay-modal" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
            <i className="fas fa-box-open" style={{ marginRight: '8px' }}></i>
            İade Kargo Detayı {data.iadeKargoNumarasi && `- ${data.iadeKargoNumarasi}`}
          </h2>
          <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Kapat">
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="modal-body">
          <div className="iade-kargo-detay-grid">
            <div className="iade-kargo-detay-field">
              <span className="label">İade Kargo No</span>
              <span className="value highlight">{iadeKargo.iadeKargoNumarasi || '—'}</span>
            </div>
            <div className="iade-kargo-detay-field">
              <span className="label">Sipariş No / Kaynak</span>
              <span className="value">{data.siparisNumarasi || '—'}</span>
            </div>
            <div className="iade-kargo-detay-field">
              <span className="label">Teknik Servis</span>
              <span className="value">{data.teknikServisAdi || '—'}</span>
            </div>
            {(data.teknikServisTelefon || data.teknikServisYetkiliTelefon) && (
              <div className="iade-kargo-detay-field">
                <span className="label">İletişim</span>
                <span className="value">
                  {data.teknikServisTelefon || '—'}
                  {data.teknikServisYetkiliKisi
                    ? ` · ${data.teknikServisYetkiliKisi}${data.teknikServisYetkiliTelefon ? ` (${data.teknikServisYetkiliTelefon})` : ''}`
                    : (data.teknikServisYetkiliTelefon ? ` · ${data.teknikServisYetkiliTelefon}` : '')}
                </span>
              </div>
            )}
            {data.teknikServisAdres && (
              <div className="iade-kargo-detay-field" style={{ gridColumn: '1 / -1' }}>
                <span className="label">Adres</span>
                <span className="value">{data.teknikServisAdres}</span>
              </div>
            )}
            {servisKaydiId && (
              <div className="iade-kargo-detay-field">
                <span className="label">Servis Kaydı</span>
                <span className="value">
                  <button
                    type="button"
                    className="btn btn-link btn-sm p-0"
                    style={{ fontWeight: 500, textDecoration: 'underline' }}
                    onClick={() => {
                      const idStr = extractIdStr(servisKaydiId);
                      if (idStr) {
                        onClose?.();
                        navigate(`/service-records/${idStr}/update`);
                      }
                    }}
                  >
                    {servisKaydiNumarasi || extractIdStr(servisKaydiId) || '—'}
                  </button>
                </span>
              </div>
            )}
            {stoktanIade && (
              <div className="iade-kargo-detay-field">
                <span className="label">Kaynak</span>
                <span className="value">Stoktan iade</span>
              </div>
            )}
            {iadeFaturaId && (
              <div className="iade-kargo-detay-field">
                <span className="label">İade Faturası</span>
                <span className="value">
                  <button
                    type="button"
                    className="btn btn-link btn-sm p-0"
                    style={{ fontWeight: 500, textDecoration: 'underline' }}
                    onClick={() => {
                      onClose?.();
                      navigate(isTechService ? '/tech-service/iade-faturalari' : '/iade-faturalari', {
                        state: { openIadeFaturaId: extractIdStr(iadeFaturaId) },
                      });
                    }}
                  >
                    İade faturası detayı
                  </button>
                </span>
              </div>
            )}
            <div className="iade-kargo-detay-field">
              <span className="label">Oluşturma Tarihi</span>
              <span className="value">{formatDateTime(data.olusturmaTarihi)}</span>
            </div>
            <div className="iade-kargo-detay-field">
              <span className="label">Durum</span>
              <span className={`value status-badge ${kargoBekliyor ? 'status-bekliyor' : durum === 'Tamamlandi' ? 'status-tamamlandi' : ''}`}>
                {DURUM_LABEL[durum] || durum}
              </span>
            </div>
            {data.kargoFirmasi && (
              <>
                <div className="iade-kargo-detay-field">
                  <span className="label">Kargo Firması</span>
                  <span className="value">{data.kargoFirmasi}</span>
                </div>
                <div className="iade-kargo-detay-field">
                  <span className="label">Takip No</span>
                  <span className="value">{data.kargoTakipNo || '—'}</span>
                </div>
              </>
            )}
          </div>

          <div className="iade-kargo-detay-section">
            <div className="iade-kargo-detay-section-title">
              <i className="fas fa-cogs" style={{ marginRight: '6px' }}></i>
              İade Edilen Parçalar (Garanti dahilinde değiştirilen)
            </div>
            {parcalar.length > 0 ? (
              <div className="iade-kargo-detay-table-wrap">
                <table className="admins-table">
                  <thead>
                    <tr>
                      <th>Parça Adı</th>
                      <th>Kod</th>
                      <th style={{ textAlign: 'center', width: '80px' }}>Adet</th>
                    </tr>
                  </thead>
                  <tbody>
                    {parcalar.map((p, i) => (
                      <tr key={i}>
                        <td>{p.parcaAdi || '—'}</td>
                        <td className="muted">{p.parcaKodu || '—'}</td>
                        <td style={{ textAlign: 'center', fontWeight: 600 }}>{p.adet != null ? Number(p.adet) : 1}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div style={{ padding: '12px 16px', fontSize: 13, color: 'var(--text-gray)' }}>Bu kategoride parça bulunmuyor</div>
            )}
          </div>

          <div className="iade-kargo-detay-section">
            <div className="iade-kargo-detay-section-title">
              <i className="fas fa-undo" style={{ marginRight: '6px' }}></i>
              Kullanılmamış Parçalar
            </div>
            {kullanilmamisaparcalar.length > 0 ? (
              <div className="iade-kargo-detay-table-wrap">
                <table className="admins-table">
                  <thead>
                    <tr>
                      <th>Parça Adı</th>
                      <th>Kod</th>
                      <th style={{ textAlign: 'center', width: '80px' }}>Adet</th>
                    </tr>
                  </thead>
                  <tbody>
                    {kullanilmamisaparcalar.map((p, i) => (
                      <tr key={i}>
                        <td>{p.parcaAdi || '—'}</td>
                        <td className="muted">{p.parcaKodu || '—'}</td>
                        <td style={{ textAlign: 'center', fontWeight: 600 }}>{p.adet != null ? Number(p.adet) : 1}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div style={{ padding: '12px 16px', fontSize: 13, color: 'var(--text-gray)' }}>Bu kategoride parça bulunmuyor</div>
            )}
          </div>

          {cihazlar.length > 0 && (
            <div className="iade-kargo-detay-section">
              <div className="iade-kargo-detay-section-title">
                <i className="fas fa-laptop" style={{ marginRight: '6px' }}></i>
                Cihazlar (Cihaz Değişimi)
              </div>
              <div className="iade-kargo-detay-table-wrap">
                <table className="admins-table">
                  <thead>
                    <tr>
                      <th>Seri No</th>
                      <th>Ürün Adı</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cihazlar.map((c, i) => (
                      <tr key={c.cihazId || i}>
                        <td>{c.seriNumarasi || '—'}</td>
                        <td>{c.urunAdi || '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div className="iade-kargo-detay-actions">
            {kargoBekliyor && isTechService && onKargoGir && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={onKargoGir}
              >
                <i className="fas fa-truck" style={{ marginRight: '8px' }}></i>
                Kargo Bilgisi Gir
              </button>
            )}
            {kargoda && onKargoTeslimAl && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={onKargoTeslimAl}
              >
                <i className="fas fa-check-double" style={{ marginRight: '8px' }}></i>
                Tamamlandı
              </button>
            )}
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Kapat
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IadeKargoDetayModal;
